module.exports = __webpack_public_path__ + "img/40_69_011_380.ef20dcca.jpg";